export interface Settings {
  block_id: string;
  username_field_label: string;
  forgot_password_section_title: string;
  forgot_password_submit_button_text: string;
}

export const defaultSettings: Settings = {
  block_id: '',
  username_field_label: 'Username',
  forgot_password_section_title: 'Forgot Password',
  forgot_password_submit_button_text: 'Send Password',
};
